<div class="powered-by">
  <span class="powered-by__text">Powered By</span>
  <img
    src="../../../../assets/images/lowl.png"
    alt="" class="powered-by__company"
    [ngClass]="{'powered-by__company_is-clickable': isClickable}"
    (click)="onClick()"
  >
</div>
